export var typeFontRegularFace = "var(--nt-font-regular-f,-apple-system,'HelveticaNeue','Helvetica Neue','Roboto','Droid Sans',Arial,sans-serif)";
export var typeFontMediumFace = "var(--nt-font-medium-f,-apple-system,'HelveticaNeue-Medium','Helvetica Neue','Roboto','Droid Sans',Arial,sans-serif)";
export var typeFontBoldFace = "var(--nt-font-bold-f,-apple-system,'HelveticaNeue-Bold','Helvetica Neue','Roboto','Droid Sans','Arial Bold',Arial,sans-serif)";
export var typeFontRegularWeight = 'var(--nt-font-regular-w,400)';
export var typeFontMediumWeight = 'var(--nt-font-medium-w,500)';
export var typeFontBoldWeight = 'var(--nt-font-bold-w,700)';
export var typeFontRegularClass = 'nt-regular';
export var typeFontMediumClass = 'nt-medium';
export var typeFontBoldClass = 'nt-bold';
export var typeSizeFoot = 'var(--nt-size-foot,.625rem)';
export var typeSizeSmall = 'var(--nt-size-small,.75rem)';
export var typeSizeNormal = 'var(--nt-size-normal,.875rem)';
export var typeSizeLarge = 'var(--nt-size-large,1rem)';
export var typeSizeTitle = 'var(--nt-size-title,1.25rem)';
export var typeSizeFootLatin = 'var(--nt-size-foot-l,.75rem)';
export var typeSizeSmallLatin = 'var(--nt-size-small-l,.875rem)';
export var typeSizeNormalLatin = 'var(--nt-size-normal-l,1rem)';
export var typeSizeLargeLatin = 'var(--nt-size-large-l,1.25rem)';
export var typeSizeTitleLatin = 'var(--nt-size-title-l,1.5rem)';
export var typeSizeSmallLatinPara = 'var(--nt-size-small-lp,1.25rem)';
export var typeSizeNormalLatinPara = 'var(--nt-size-normal-lp,1.25rem)';
export var typeSizeLargeLatinPara = 'var(--nt-size-large-lp,1.375rem)';
export var typeSizeFootTall = 'var(--nt-size-foot-t,1rem)';
export var typeSizeSmallTall = 'var(--nt-size-small-t,1.125rem)';
export var typeSizeNormalTall = 'var(--nt-size-normal-t,1.375rem)';
export var typeSizeLargeTall = 'var(--nt-size-large-t,1.5rem)';
export var typeSizeTitleTall = 'var(--nt-size-title-t,1.875rem)';
export var typeSizeSmallTallPara = 'var(--nt-size-small-tp,1.125rem)';
export var typeSizeNormalTallPara = 'var(--nt-size-normal-tp,1.375rem)';
export var typeSizeLargeTallPara = 'var(--nt-size-large-tp,1.5rem)';
export var typeSizeFootClass = 'nt-foot';
export var typeSizeFootParaClass = 'nt-foot-p';
export var typeSizeSmallClass = 'nt-small';
export var typeSizeSmallParaClass = 'nt-small-p';
export var typeSizeNormalClass = 'nt-normal';
export var typeSizeNormalParaClass = 'nt-normal-p';
export var typeSizeLargeClass = 'nt-large';
export var typeSizeLargeParaClass = 'nt-large-p';
export var typeSizeTitleClass = 'nt-title';
export var typeSizeTitleParaClass = 'nt-title-p';